import React, { Component } from 'react';
import { Button, Icon, Modal } from './';
import CSSModules from 'react-css-modules';
import style from './alert.scss';

const iconMap = {
  success: 'check',
  warning: 'times'
};

@CSSModules(style, { allowMultiple: true })
export default class Alert extends Component {
  render() {
    const { message, type, title, onClose } = this.props;

    const content = (
      <div styleName="root">
        <p styleName={`title type-${type}`}><Icon name={iconMap[type]} /> {title}</p>
        <div>{message}</div>
        <div styleName="button-container">
          <Button type="weak" onClick={onClose}>OKAY</Button>
        </div>
      </div>
    );

    return (
      <Modal
        isOpen={true}
        closeable={false}
        showHeader={false}
        size="small"
      >
      {content}
      </Modal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/alert.js